import React from "react";
import './GIECard.css'

function GieCard({...props}) {
  const {
    children,
    big,
    height,
    width,
    clickable,
    className,
    contentFullHeight,
    style,
    ...restProps
  } = props;

  return (
    <div className={`white-card ${clickable ? 'clickable-div' : ''} ${className ?? ''}`} { ...restProps } style={{
      height: height ?? '30vh',
      width: width ?? '16vw',
      ...style
    }}>
      {clickable && <div className="clickable-div-elem"></div>}

      <div className={`card-content ${contentFullHeight ? 'h-100' : ''}`}>
        {children}
      </div>
    </div>
  );
}

export default (GieCard);
